var _circle, _circle2, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfileEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 106"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 89.9835,
    cy: 89.6266,
    r: 88.9835,
    fill: "#F9FAFC",
    stroke: "#CACFD9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 105"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    cx: 89.5,
    cy: 89.1431,
    r: 13,
    fill: "#333B4F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_335_4665",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 78,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 78.864,
    y: 78.5068,
    width: 21.721,
    height: 21.721,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_335_4665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_2",
    d: "M88.8195 90.2725H83.3893V88.4625H88.8195V83.0322H90.6296V88.4625H96.0598V90.2725H90.6296V95.7028H88.8195V90.2725Z",
    fill: "white"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfileEmpty);
export default __webpack_public_path__ + "static/media/img_profile_empty.53ffba6b9322500a04c679d8e2e80ff9.svg";
export { ForwardRef as ReactComponent };